export const FETCH_HISTORYLIST_REQUEST = "FETCH_HISTORYLIST_REQUEST";
export const FETCH_HISTORYLIST_SUCCESS = "FETCH_HISTORYLIST_SUCCESS";
export const FETCH_HISTORYLIST_FAILURE = "FETCH_HISTORYLIST_FAILURE";
